import { Map } from 'immutable';

import * as types from './types';
import * as historyTypes from './../test-history/types';
import * as overviewTypes from './../test-overview/types';
import * as constants from './constants';
import { REQUEST_CANCEL_MESSAGE } from './../../constants';

const initialState = new Map({
  loading: true,
  errors: new Map({
    getTests: null,
    getOrganization: null,
    getMetrics: null,
    getTrends: null,
    getErrors: null,
    getAggregatedTestNames: null,
    getFailureTests: null,
  }),
});

const setError = (state, type, err = null) => state.setIn(['errors', type], err);

const viewReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.LOAD_INIT_DATA.SUCCESS:
      return state.set('loading', false);
    case types.LOAD_INIT_DATA.FAILURE:
      return state.set('loading', false);
    case types.LOADING_COMPLETE:
      return state.set('loading', false);
    case historyTypes.GET_TEST_METRICS.FAILURE:
      return setError(state, 'getMetrics', constants.ERROR_FAILED_LOAD_METRICS);
    case historyTypes.GET_TEST_METRICS.REQUEST:
      return setError(state, 'getMetrics', null);
    case historyTypes.GET_TESTS.FAILURE: {
      if (payload && payload.message === REQUEST_CANCEL_MESSAGE) {
        return state;
      }
      return setError(state, 'getTests', constants.ERROR_FAILED_GET_TESTS);
    }
    case overviewTypes.GET_AGGREGATED_TEST_NAMES.FAILURE:
      return setError(state, 'getAggregatedTestNames', constants.ERROR_FAILED_LOAD_AGGREGATED_TEST_NAMES);
    case overviewTypes.GET_TEST_TRENDS.FAILURE:
      return setError(state, 'getTrends', constants.ERROR_FAILED_LOAD_TEST_TRENDS);
    case overviewTypes.GET_AGGREGATED_TEST_ERRORS.FAILURE:
      return setError(state, 'getAggregatedTestErrors', constants.ERROR_FAILED_LOAD_ERRORS);
    case overviewTypes.GET_PAST_TRENDS.FAILURE:
      return setError(state, 'getPastTrends', constants.ERROR_FAILED_LOAD_PAST_TRENDS);
    case historyTypes.GET_TESTS.SUCCESS:
      return state.set('errors', new Map({
        getTests: null,
        getOrganization: null,
        getMetrics: null,
        getTrends: null,
        getErrors: null,
        getAggregatedTestNames: null,
      }));
    case overviewTypes.GET_AGGREGATED_TEST_NAMES.SUCCESS:
      return setError(state, 'getAggregatedTestNames', null);
    case overviewTypes.GET_TEST_TRENDS.SUCCESS:
      return setError(state, 'getTrends', null);
    case overviewTypes.GET_AGGREGATED_TEST_ERRORS.SUCCESS:
      return setError(state, 'getAggregatedTestErrors', null);
    case overviewTypes.GET_PAST_TRENDS.SUCCESS:
      return setError(state, 'getPastTrends', null);
    case types.GET_ORGANIZATION.REQUEST:
      return setError(state, 'getOrganization', null);
    case types.GET_ORGANIZATION.FAILURE:
      return setError(state, 'getOrganization', constants.ERROR_FAILED_LOAD_ORGANIZATION);
    // get test names
    default:
      return state;
  }
};

export default viewReducer;
export { initialState };
